const etcsVariablePrefixes = [
  { prefix: "A_", meaning: "Acceleration" },
  { prefix: "D_", meaning: "Distance" },
  { prefix: "G_", meaning: "Gradient" },
  { prefix: "L_", meaning: "Length" },
  { prefix: "M_", meaning: "Miscellaneous" },
  { prefix: "N_", meaning: "Number" },
  { prefix: "NC_", meaning: "Class number" },
  { prefix: "NID_", meaning: "Identity number" },
  { prefix: "Q_", meaning: "Qualifier" },
  { prefix: "T_", meaning: "Time/date" },
  { prefix: "V_", meaning: "Speed" },
  { prefix: "X_", meaning: "Text" }
];

const sortedPrefixes = [...etcsVariablePrefixes].sort((left, right) => (
  left.prefix.localeCompare(right.prefix, undefined, { numeric: true, sensitivity: "base" })
));

export default function EtcsVariablePrefixes() {
  const stickyHeaderStyle = {
    position: "sticky",
    top: 0,
    zIndex: 1,
    backgroundColor: "var(--bs-table-bg, #f8f9fa)"
  };

  const getRowStyle = (index) => ({
    "--bs-table-bg": index % 2 === 0 ? "rgba(25, 135, 84, 0.06)" : "#ffffff"
  });

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center gap-3 mb-3 flex-wrap">
        <div>
          <h3 className="mb-1">ETCS Variables Prefixes</h3>
          <div className="text-muted">
            Standard prefixes used in ETCS variable names.
          </div>
        </div>

        <span className="badge text-bg-secondary">
          Total: {sortedPrefixes.length}
        </span>
      </div>

      <table className="table table-hover align-middle mb-0">
        <thead className="table-light">
          <tr>
            <th style={{ ...stickyHeaderStyle, width: "180px" }}>Prefix</th>
            <th style={stickyHeaderStyle}>Meaning</th>
          </tr>
        </thead>

        <tbody>
          {sortedPrefixes.map((item, index) => (
            <tr key={item.prefix} style={getRowStyle(index)}>
              <td className="fw-semibold">{item.prefix}</td>
              <td>{item.meaning}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}